import { render } from "./InlineLoadingWidgetSmall.vue?vue&type=template&id=6df482b2"
import script from "./InlineLoadingWidgetSmall.vue?vue&type=script&lang=js"
export * from "./InlineLoadingWidgetSmall.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__